import { render } from "./headlineBig.vue?vue&type=template&id=5a654c58"
import script from "./headlineBig.vue?vue&type=script&lang=js"
export * from "./headlineBig.vue?vue&type=script&lang=js"

import "./headlineBig.vue?vue&type=style&index=0&id=5a654c58&lang=scss"

import exportComponent from "C:\\Users\\chbo\\Documents\\repos\\semco-maritime-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__